import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "templates-header",
  class: "default-header uk-flex uk-flex-between uk-flex-middle"
}
const _hoisted_2 = { class: "templates-header-left uk-flex uk-flex-column" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = { class: "sub-header" }
const _hoisted_5 = { class: "templates-header-right uk-padding-small uk-flex uk-flex-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_navigation = _resolveComponent("the-navigation")!
  const _component_user_menu = _resolveComponent("user-menu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "custom-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('header.title')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_the_navigation, { class: "uk-margin-right" }),
      _createVNode(_component_user_menu, {
        onLogout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
      })
    ])
  ]))
}